import {
    fetchJsonPost,
    fetchUrlGet,
    fetchBasicGetJson
} from '@/script/common';

export default {
    signIn: params => fetchJsonPost('/Account/SignIn', { data: params }),
    signOut: () => fetchUrlGet('/Account/SignOut',{ data: {} }),
    getSettings: ()=> fetchBasicGetJson('/Account/GetSettings')
};
